export default __webpack_public_path__ + "static/media/second-right.88c38b46.png";